export const normalizedUrl = (url: string) => {
  if (url.includes('https')) {
    return url.split('://')[1];
  }
  return url;
};
